import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class FinalizeAccEntries  {
    _originalTypeClassName = "zERP.BO.FinalizeAccEntries";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
FinalizeAccEntries.translate = translateService;
}
this.Entity = new Domain.AccountingBusinessEntity();
this.ID = null;
this.EndDate = null;
this.StartDate = null;
this.CommitTransactions = false;
this.UncommitTransactions = false;
this.ExecutionDate = null;
this._key = this.ID = 0; 
}

static translate: TranslateService;
_key: any;
private _ID:any;
get ID(): any {
    return this._ID;
  }
set ID(value: any) {
    this._ID = value;
    this._key = value;
  }
EndDate:any;
StartDate:any;
CommitTransactions:any;
UncommitTransactions:any;
ExecutionDate:any;
Ledger:any;
FiscalPeriod:any;
Entity:any;
ExecutedBy:any;
static setLedger = ($this, value) => {
var oldValue = $this.Ledger;
$this.Ledger = value;
if (value != null) {
}
}
static setFiscalPeriod = ($this, value) => {
var oldValue = $this.FiscalPeriod;
$this.FiscalPeriod = value;
if (value != null) {
}
}
static setEntity = ($this, value) => {
var oldValue = $this.Entity;
$this.Entity = value;
if (value != null) {
}
}
static setExecutedBy = ($this, value) => {
var oldValue = $this.ExecutedBy;
$this.ExecutedBy = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.ID == null || $this.ID == 0;
            }


}